import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useBuildingTableStore,
  initialBuildingColumns,
} from 'views/pages/Admin/Buildings/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type BuildingColumnKey =
  | 'name'
  | 'partner_name'
  | 'operator_name'
  | 'wellness_coordinators'
  | 'city'
  | 'address'
  | 'total_beds';

const BUILDING_TABLE_COLUMN_LABELS: Record<BuildingColumnKey, string> = {
  name: 'Building',
  partner_name: 'Partner',
  operator_name: 'Operator',
  wellness_coordinators: 'Wellness Coordinator',
  city: 'City / State',
  address: 'Address',
  total_beds: 'Total Beds',
};

const ALL_FIELDS = initialBuildingColumns.map(
  c => c.field,
) as BuildingColumnKey[];

export const BuildingTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useBuildingTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useBuildingTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<BuildingColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<BuildingColumnKey, ColumnPreferencesConfig>>,
  ) => {
    const nextHidden = ALL_FIELDS.filter(
      field => selection[field]?.column_display === 'hidden',
    );
    setHiddenColumns(nextHidden);
  };

  const handleReset = () => {
    setHiddenColumns([]);
  };

  return (
    <ColumnSelectionFilter
      name='building_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={BUILDING_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={handleReset}>
          RESET
        </Button>
      }
    />
  );
};
